import { Grid } from "@mui/material";
import DashboardTable from "./table";
import WSDataGridForDashboard from "../../Components/DataGrid/WSDataGridForDashboard";

function DashboardTables({ leads }: { leads: any[] }) {
  return (
    <Grid container spacing={3} mt={2} ml={1}>
      <Grid item xs={12}>
        {/* Left column tables */}
        {/* <DashboardTable
          title="✅ Pending Approvals"
          columns={[
            { label: "Name", field: "name" },
            { label: "Type", field: "type" },
            { label: "Submitted On", field: "submittedOn" },
            { label: "Status", field: "status" }
          ]}
          data={leads
            .filter((l: any) => l.status?.toLowerCase() === "pending")
            .map((l: any) => ({
              name: `${l.firstName} ${l.lastName}`,
              type: "Installation", // You can customize
              submittedOn: new Date(l.createdAt).toLocaleDateString(),
              status: l.status
            }))}
        /> */}

        <WSDataGridForDashboard
          title={"✅ Pending Approvals"}
          columns={[
            { header: "Name", fieldName: "name" },
            { header: "Type", fieldName: "type" },
            { header: "Submitted On", fieldName: "submittedOn" },
            { header: "Status", fieldName: "status" }
          ]}
          data={leads
            .filter((l: any) => l.status?.toLowerCase() === "pending")
            .map((l: any) => ({
              name: `${l.firstName} ${l.lastName}`,
              type: "Installation", // You can customize
              submittedOn: new Date(l.createdAt).toLocaleDateString(),
              status: l.status
            }))}
          id="pendingLeads"
          pageSize={10}
        />

        <WSDataGridForDashboard
          title="📥 Support Tickets"
          columns={[
            { header: "Ticket ID", fieldName: "id" },
            { header: "Subject", fieldName: "subject" },
            { header: "Customer", fieldName: "customer" },
            { header: "Status", fieldName: "status" }
          ]}
          data={[
            {
              id: "TKT123",
              subject: "Inverter issue",
              customer: "Akshay",
              status: "Open"
            },
            {
              id: "TKT124",
              subject: "Low output",
              customer: "Anjali",
              status: "Resolved"
            }
          ]}
          id="ticketsId"
          pageSize={10}
          mt={2}
        />

        {/* <DashboardTable
          title="📥 Support Tickets"
          columns={[
            { label: "Ticket ID", field: "id" },
            { label: "Subject", field: "subject" },
            { label: "Customer", field: "customer" },
            { label: "Status", field: "status" }
          ]}
          data={[
            {
              id: "TKT123",
              subject: "Inverter issue",
              customer: "Akshay",
              status: "Open"
            },
            {
              id: "TKT124",
              subject: "Low output",
              customer: "Anjali",
              status: "Resolved"
            }
          ]}
        /> */}
      </Grid>

      <Grid item xs={12} md={6}>
        {/* Right column tables */}
        <DashboardTable
          title="📸 Install Photos"
          columns={[
            { label: "Site", field: "site" },
            { label: "Photo Type", field: "type" },
            { label: "Uploaded By", field: "user" },
            { label: "Date", field: "date" }
          ]}
          data={[
            {
              site: "Palakkad",
              type: "Before",
              user: "John",
              date: "2025-06-15"
            },
            {
              site: "Kozhikode",
              type: "After",
              user: "Ravi",
              date: "2025-06-16"
            }
          ]}
        />

        <DashboardTable
          title="🔧 Service History"
          columns={[
            { label: "Panel ID", field: "panelId" },
            { label: "Date", field: "date" },
            { label: "Issue", field: "issue" },
            { label: "Technician", field: "tech" }
          ]}
          data={[
            {
              panelId: "PNL001",
              date: "2025-06-10",
              issue: "Dust Block",
              tech: "Sreejith"
            }
          ]}
        />

        <DashboardTable
          title="🔄 AMC & Renewals"
          columns={[
            { label: "Customer", field: "customer" },
            { label: "Service", field: "service" },
            { label: "Due Date", field: "due" },
            { label: "Reminder Sent", field: "reminder" }
          ]}
          data={[
            {
              customer: "GreenTech Ltd",
              service: "Annual Panel Wash",
              due: "2025-06-25",
              reminder: "Yes"
            },
            {
              customer: "EcoPower Pvt",
              service: "AMC",
              due: "2025-07-01",
              reminder: "No"
            }
          ]}
          mt={2}
        />
      </Grid>
    </Grid>
  );
}

export default DashboardTables;
